<template>
    <div>
     <div class="row wrapper border-bottom white-bg page-heading p-2">
      <div class="col-lg-10">
        <h2>Historical Baseline vs RBQM Dashboard</h2>
        <small> Comparing trial’s operational performance, risk profile and data
        signals against historical benchmarks</small>
      </div>
      <div class="col-lg-2 align-self-center" v-if="showCloseButton == true">
        <i class="fa fa-times close" @click="$router.go(-1)"></i>
      </div>
    </div>
    
  <div class="py-2 rbqm-dashboard">
    <!-- Filter Controls -->
    <div class="controls">
      <!-- <div class="control-group">
        <label for="study-select">Our Study</label>
        <select
        class="form-control"
          id="study-select"
          v-model="selectedStudy"
          @change="updateDashboard"
        >
          <option v-for="study in srtudylist" :key="study.studyId" :value="study.studyId">{{ study.studyRef }}</option>
        </select>
      </div> -->

      <div class="control-group">
        <label for="therapeutic-area">Therapeutic Area / Condition</label>
        <div class="search-input-wrapper">
          <input
            id="therapeutic-area"
            class="form-control therapeutic-input"
            type="text"
            v-model="therapeuticArea"
            @input="autofillFun"
            @focus="showSuggestions = true"
            @blur="handleBlur"
          />

          <!-- Right-side search icon (no button) -->
          <i class="fa fa-search search-icon" @click="updateDashboard"></i>

          <!-- Custom dropdown suggestions -->
          <ul
            v-if="showSuggestions && autofilldata && autofilldata.length"
            class="suggestions-dropdown list-group"
          >
            <li
              v-for="value in autofilldata"
              :key="value"
              class="list-group-item suggestion-item"
              @mousedown.prevent="selectSuggestion(value)"
            >
              {{ value }}
            </li>
          </ul>
        </div>
      </div>

      <div class="control-group">
        <label for="study-phase">Phase</label>
        <select
        class="form-control"
          id="study-phase"
          v-model="studyPhase"
          @change="updateDashboard"
        >
          <option value="PHASE1">Phase 1</option>
          <option value="PHASE2">Phase 2</option>
          <option value="PHASE3">Phase 3</option>
          <option value="PHASE4">Phase 4</option>
        </select>
      </div>

      <div class="control-group">
        <label for="time-range">Time Range</label>
        <select
        class="form-control"
          id="time-range"
          v-model="timeRange"
          @change="updateDashboard"
        >
          <option value="2">Last 2 Years</option>
          <option value="5">Last 5 Years</option>
          <option value="7">Last 7 Years</option>
          <option value="10">Last 10 Years</option>
        </select>
      </div>
    </div>
<!-- KPI Cards -->
      <div class="row g-2 mb-2 kpi-container">

        <div class="col-12 col-sm-6 col-md-3">
          <div class="card kpi-card">
            <div class="card-body p-0 d-flex justify-content-between align-items-center">
              <p class="mb-0 text-muted">Total Study</p>
              <h3 class="mb-1">{{ totalstudycount }}</h3>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <div class="card kpi-card h-100">
            <div class="card-body p-0 d-flex justify-content-between align-items-center">
              <p class="mb-0 text-muted">Completed Study</p>
              <h3 class="mb-1">{{ completedstudycount }}</h3>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <div class="card kpi-card h-100">
            <div class="card-body p-0 d-flex justify-content-between align-items-center">
              <p class="mb-0 text-muted">Terminated Study</p>
              <h3 class="mb-1">{{ terminatedstudycount }}</h3>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-3">
          <div class="card kpi-card h-100">
            <div class="card-body p-0 d-flex justify-content-between align-items-center">
              <p class="mb-0 text-muted">Withdrawn Study</p>
              <h3 class="mb-1">{{ withdrawnstudycount }}</h3>
            </div>
          </div>
        </div>
      </div>
    <!-- Row 1: Performance Comparison -->
    <div class="grid-2">
        <div class="chart-container">
          <h4>Performance vs Historical Baseline</h4>
            <!-- Loader -->
            <div
              v-if="loadingPerformance"
              class="d-flex justify-content-center align-items-center py-5">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

          <!-- Chart -->
          <apexchart
            v-else
            type="bar"
            height="290"
            :options="performanceOptions"
            :series="performanceSeries"
          />
      </div>
      <div class="chart-container">
        <h4>Enrollment rate</h4>
        <small>Total Studies : {{ totalstudyforenrollments }}</small>
        <!-- Loader -->
        <div
          v-if="loadingenrollmentsPerf"
          class="d-flex justify-content-center align-items-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <!-- Chart -->
        <apexchart
          v-else
          type="bar"
          height="290"
          :options="enrollmentsOptions"
          :series="enrollmentsSeries"/>
      </div>
     <!-- <div class="chart-container">
  <h3>Site Performance Benchmarking</h3>
  <div
    v-if="sitePerformanceLoading"
    class="d-flex justify-content-center align-items-center"
    style="height: 380px;"
  >
    <div class="spinner-border" role="status" aria-label="Loading">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <apexchart
    v-else
    type="bar"
    height="380"
    :options="sitePerformanceOptions"
    :series="sitePerformanceSeries"
  />
</div> -->
    </div>

    <!-- Row 2: Protocol Complexity & Site Performance -->
     <!-- <div class="grid-1">

      <div class="chart-container">
  <h3>Quality Tolerance Limits – Breach Trend</h3>
  <div
    v-if="loadingQtl"
    class="d-flex justify-content-center align-items-center py-5"
  >
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <apexchart
    v-else
    type="line"
    height="380"
    :options="qtlOptions"
    :series="qtlSeries"
  />
</div>
    </div>  -->
    
    <!-- Row 3:horizondal -->
     <!-- <div class="grid-2"> -->

<!-- <div class="chart-container">
  <h3>Risk Factors</h3>

  <div
    v-if="loadingHorizontalPerf"
    class="d-flex justify-content-center align-items-center py-5"
  >
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <apexchart
    v-else
    type="bar"
    height="300"
    :options="horizondalperformanceOptions"
    :series="horizondalperformanceSeries"
  />
</div> -->
    <!-- </div>  -->
    <!-- Row 4: Protocol Complexity & Site Performance -->
     <div class="grid-1">
      <div class="chart-container">
        <h4>Site Enrollment rate</h4>
        <div
          v-if="loadingsiteenrollmentrate"
          class="d-flex justify-content-center align-items-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <apexchart
          v-else
          type="bar"
          height="380"
          :options="siteenrollmentsOptions"
          :series="siteenrollmentsSeries"/>
      </div>
    </div> 
  </div>
  </div>
</template>

<script src="./AACT_Study_Comparison.js"></script>

<style scoped>
.aact-rbqm-dashboard {
  /* CSS variables local to this component */
  --primary-color-comp: #2c3e50;
  --secondary-color-comp: #3498db;
  --success-color-comp: #27ae60;
  --warning-color-comp: #f39c12;
  --danger-color-comp: #e74c3c;
  --light-gray-comp: #ecf0f1;
  --dark-gray-comp: #7f8c8d;

}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Put font-family on the container instead */
.aact-rbqm-dashboard {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */

.header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(
    135deg,
    var(--primary-color-comp),
    var(--secondary-color-comp)
  );
  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header h1 {
  font-size: 2.4rem;
  margin-bottom: 8px;
}

.header p {
  font-size: 1rem;
  opacity: 0.9;
}

/* Controls */

.controls {
  background: white;
  padding: 8px 12px;
  border-radius: 10px;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

.control-group {
  display: flex;
  flex-direction: column;
}

.control-group label {
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--primary-color-comp);
}

select,
input[type="range"] {
  padding: 10px;
  border: 2px solid var(--light-gray-comp);
  border-radius: 5px;
  font-size: 14px;
}

select:focus,
input[type="range"]:focus {
  outline: none;
  border-color: var(--secondary-color-comp);
}

/* KPI */

.kpi-container {
  margin-bottom: 20px;
}

.kpi-label {
  font-size: 0.8rem;
  color: var(--dark-gray-comp);
  margin-bottom: 6px;
}

.kpi-value {
  font-size: 1.8rem;
  color: var(--primary-color-comp);
  font-weight: 600;
  margin-bottom: 4px;
}

.kpi-sub {
  font-size: 0.8rem;
  color: var(--dark-gray-comp);
}
/* KPI cards */
.kpi-card {
  border-left: 4px solid var(--secondary-color);
  border-radius: 0.75rem;
}

.kpi-card h3 {
  color: var(--primary-color);
  font-size: 22px;
  font-weight: 600;
}

.kpi-card p {
  color: var(--dark-gray);
  font-size: 12px;
}


/* Charts & Layout */

.chart-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chart-container h3 {
  color: var(--primary-color-comp);
  margin-bottom: 10px;
  font-size: 1.25rem;
}

.chart-subtitle {
  font-size: 0.8rem;
  color: var(--dark-gray-comp);
  margin-bottom: 10px;
}

.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.grid-1 {
  grid-column: 1 / -1;
}

@media (max-width: 900px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .controls {
    grid-template-columns: 1fr;
  }
}

/* Complexity charts */

.complexity-charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.complexity-chart {
  width: 100%;
}

/* Risk indicator */

.risk-indicator {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.risk-low {
  background: var(--success-color-comp);
  color: white;
}

.risk-medium {
  background: var(--warning-color-comp);
  color: white;
}

.risk-high {
  background: var(--danger-color-comp);
  color: white;
}

/* Table */

table {
  border-collapse: collapse;
  width: 100%;
  font-size: 0.85rem;
}

th,
td {
  padding: 10px;
  text-align: left;
}

thead tr {
  background-color: var(--light-gray-comp);
}

tbody tr:nth-child(even) {
  background-color: #f7f9fb;
}
.search-input-wrapper {
  position: relative;
}
.suggestions-dropdown {
  position: absolute;
  top: 100%;           /* exactly below the input */
  left: 0;
  right: 0;
  z-index: 1050;
  max-height: 220px;
  overflow-y: auto;
  margin-top: 2px;
}
.suggestion-item {
  cursor: pointer;
  font-size: 0.9rem;
}

.suggestion-item:hover {
  background-color: #f1f1f1;
}
/* The text box */
.therapeutic-input {
  padding-right: 2rem; /* space for the search icon on the right */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Hide the datalist dropdown arrow in WebKit browsers (Chrome/Edge) */
.therapeutic-input::-webkit-calendar-picker-indicator {
  display: none !important;
}

/* Search icon inside the input on the right */
.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  /* pointer-events: none;  <-- remove this line */
  cursor: pointer;          /* optional: show hand cursor */
  font-size: 0.9rem;
}
</style>
